<template>
  <div class="cont">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 col-xl-4">
          <div class="card">
            <div class="card-body">
              <h6 class="header-title mb-0">AYLIK GELİR</h6>
              <div class="pt-3 text-center">
                <div class="row mt-3">
                  <div class="col-3">
                    <h5 class="mb-1 currency">22.538</h5>
                    <p class="text-muted text-truncate">TOPLAM GELİR</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1 currency">14.538</h5>
                    <p class="text-green text-truncate">YENİ SATIŞ GELİRİ</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1 currency">7.000</h5>
                    <p class="text-blue text-truncate">AİDAT GELİRİ</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1 currency">1.000</h5>
                    <p class="text-red text-truncate">DİĞER</p>
                  </div>
                </div>
              </div>
              <div id="pie-chart-monthly-revenue"></div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4">
          <div class="card">
            <div class="card-body">
              <h6 class="header-title mb-0">SÖZLEŞME YENİLEME ORANI</h6>
              <div class="pt-3 text-center">
                <div class="row mt-3">
                  <div class="col-3">
                    <h5 class="mb-1">148</h5>
                    <p class="text-muted text-truncate">TOPLAM SÖZLEŞME</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1">91</h5>
                    <p class="text-green text-truncate">YENİLENEN SÖZLEŞME</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1">366</h5>
                    <p class="text-muted text-truncate">TOPLAM CİHAZ</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1">125</h5>
                    <p class="text-green text-truncate">YENİLENEN CİHAZ</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6" id="pie-chart-subscription-returnings"></div>
                  <div class="col-6" id="pie-chart-device-returnings"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4">
          <div class="card">
            <div class="card-body">
              <h6 class="header-title mb-0">GELİR - GİDER DENGESİ (SON 4 AY)</h6>
              <div class="pt-3 text-center">
                <div class="row mt-3">
                  <div class="col-3">
                    <h5 class="mb-1 data-bind decrease">3850</h5>
                    <p class="text-muted text-truncate">ARALIK 2020</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1 data-bind increase">12.000</h5>
                    <p class="text-muted text-truncate">KASIM 2020</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1 data-bind decrease">2.350</h5>
                    <p class="text-muted text-truncate">EKİM 2020</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1 data-bind increase">4.950</h5>
                    <p class="text-muted text-truncate">EYLÜL 2020</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12" id="bar-chart-balance"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xl-4">
          <div class="card">
            <div class="card-body">
              <h6 class="header-title mb-0">SATIŞ GELİRLERİ BEKLENTİSİ</h6>
              <div class="pt-3 text-center">
                <div class="row mt-3">
                  <div class="col-3">
                    <h5 class="mb-1 data-bind currency">13000</h5>
                    <p class="text-muted text-truncate">ORT. SATIŞ GELİRİ</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1 data-bind">17</h5>
                    <p class="text-green text-truncate">ORT. SATIŞ SAYISI</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1 data-bind">15</h5>
                    <p class="text-green text-truncate">ORT. ATS SATIŞI</p>
                  </div>
                  <div class="col-3">
                    <h5 class="mb-1 data-bind">2</h5>
                    <p class="text-green text-truncate">ORT. DİĞER SATIŞ</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-4">
          <div class="card">
            <div class="card-body">
              <h6 class="header-title mb-0">KASIM AYI AİDAT GELİRİ BEKLENTİSİ</h6>
              <div class="pt-3 text-center">
                <div class="row mt-3">
                  <div class="col-4">
                    <h5 class="mb-1 data-bind currency">24.200</h5>
                    <p class="text-muted text-truncate">POTANSİYEL GELİR</p>
                  </div>
                  <div class="col-4">
                    <h5 class="mb-1 data-bind percentage">61</h5>
                    <p class="text-green text-truncate">DÖNÜŞÜM ORANI</p>
                  </div>
                  <div class="col-4">
                    <h5 class="mb-1 data-bind currency">14.762</h5>
                    <p class="text-green text-truncate">GELİR BEKLENTİSİ</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'DashboardPage',
  methods: {
    prepareBarChart () {
      google.charts.load('current', {'packages':['corechart']})
      google.charts.setOnLoadCallback(this.drawCharts);
    },
    drawCharts() {
      this.dcMonthlyRevenue()
      this.dcSubscriptionReturnings()
      this.dcDeviceReturnings()
      this.dcBalance()
    },
    async dcMonthlyRevenue () {
      var data = google.visualization.arrayToDataTable([
        ['Aylık Gelir', 'TL'],
        ['Cihaz Satışı', 14538],
        ['Aidat Geliri', 7000],
        ['Diğer',  1000],
      ]);

      var options = {
        title: '',
        width: '100%',
        height: 275,
        legend: 'none',
        colors: ['#1DB954', '#007BFF', '#CC0033'],
        chartArea:{ width : '100%', height: '100%', top: 30, bottom: 10 }
      };

      var chart = new google.visualization.PieChart(document.getElementById('pie-chart-monthly-revenue'));

      chart.draw(data, options);
    },
    async dcSubscriptionReturnings () {
      var data = google.visualization.arrayToDataTable([
        ['Toplam Sözleşme', ''],
        ['Uzatılan Sözleşmeler', 91],
        ['Sona Eren Sözleşmeler', 57]
      ]);

      var options = {
        title: '',
        width: '100%',
        height: 275,
        legend: 'none',
        colors: ['#1DB954', '#CC0033'],
        chartArea:{ width : '100%', height: '100%', top: 0, bottom: 10, left: 10, right: 10 }
      };

      var chart = new google.visualization.PieChart(document.getElementById('pie-chart-subscription-returnings'));

      chart.draw(data, options);
    },
    async dcDeviceReturnings () {
      var data = google.visualization.arrayToDataTable([
        ['Toplam Cihaz', ''],
        ['Uzatılan Cihazlar', 125],
        ['Sona Eren Cihazlar', 241]
      ]);

      var options = {
        title: 'Test Title',
        width: '100%',
        height: 275,
        legend: { position: 'bottom', alignment: 'center' },
        colors: ['#1DB954', '#CC0033'],
        chartArea:{ width : '100%', height: '100%', top: 0, bottom: 10, left: 10, right: 10 },
      };

      var chart = new google.visualization.PieChart(document.getElementById('pie-chart-device-returnings'));

      chart.draw(data, options);
    },
    async dcBalance () {
      var data = google.visualization.arrayToDataTable([
        ['Dönem', 'Gelir', 'Gider', 'Kâr'],
        ['ARALIK 2020', 7650, 11500, -3850],
        ['KASIM 2020', 30000, 18000, 12000],
        ['EKİM 2020', 27000, 29250, -2250],
        ['EYLÜL 2020', 34950, 30000, 4950]
      ]);

      var options = {
        legend: 'none',
        width: '100%',
        height: 275,
        colors: ['#007BFF', '#CC0033', '#1DB954'],
        chartArea:{ width : '100%', height: '50%', top: 20, bottom: 20, left: 50 },
      };

      var chart = new google.visualization.ColumnChart(document.getElementById('bar-chart-balance'));
      chart.draw(data, options);
    }
  },
  mounted() {
    this.prepareBarChart()
  }
}
</script>

<style scoped>

  /* TEXT COLORS */

  .text-green {
    color: #1DB954;
  }

  .text-blue {
    color: #007BFF;
  }

  .text-red {
    color: #c03;
  }

  /* END COLORS */

  /* UTILITIES */

  .data-bind {
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
  }

  .percentage::before {
    content: '%';
    margin-right: 5px;
  }

  .currency::before {
    content: '₺';
    margin-right: 5px;
  }

  .increase { color: #1DB954; }
  .increase::before {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\f062";
    margin-right: 5px;
  }

  .decrease { color: #CC0033; }
  .decrease::before {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\f063";
    margin-right: 5px; 
  }

  /* END UTILITIES */

  .cont {
    padding: 30px 15px;
    width: 100%;
    min-height: 100%;
    height: auto;
    background-color: #F5F6F9;
  }

  .cont * { box-sizing: border-box; }

  /*.col-md-6.col-xl-4 {
    padding-right: 0;
  }

  .col-md-6.col-xl-4:last-child {
    padding-right: 15px;
  }*/

  .card {
    background-color: #FFF;
    border: none;
    border-radius: .25rem;
    height: auto;
    box-shadow: 0 0 35px 0 rgba(154,161,171,.075);
    margin-bottom: 30px;
  }

  .card .header-title { font-weight: 600; }
  .card h5 { font-weight: 400; }
  .card p { font-size: .75rem; }

  .card-x:last-child { margin-right: 0; }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue